import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import 'firebase/compat/storage'
import 'firebase/compat/functions'
import 'firebase/compat/app-check'
import firebaseConfig from '@/firebase-config'

// Override project ID for emulators to ensure consistency
const emulatorConfig = process.env.VUE_APP_USE_EMULATORS === 'true'
  ? { ...firebaseConfig, projectId: 'demo-ngapp5' }
  : firebaseConfig

firebase.initializeApp(emulatorConfig)

const auth = firebase.auth()
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
const authProperty = firebase.auth
const db = firebase.firestore()
const storage = firebase.storage()
const functions = firebase.functions()
const firestore = firebase.firestore

// Connect to emulators if running in emulator mode
if (process.env.VUE_APP_USE_EMULATORS === 'true') {
  console.log('🔧 Connecting to Firebase Emulators...')

  // Connect Auth to emulator
  auth.useEmulator('http://localhost:9099')

  // Connect Firestore to emulator
  db.useEmulator('localhost', 8079)

  // Connect Storage to emulator
  storage.useEmulator('localhost', 9199)

  // Connect Functions to emulator
  functions.useEmulator('localhost', 5002)

  console.log('✅ Connected to Firebase Emulators')
} else {
  console.log('🌐 Using production Firebase services')
}
// const appCheck = firebase.appCheck()

const log = function (uid, action, data) {
  db.collection('logs').add({
    uid: uid,
    action: action,
    data: data,
    timestamp: firebase.firestore.FieldValue.serverTimestamp()
  })
}

/* appCheck.activate(
  new firebase.appCheck.ReCaptchaEnterpriseProvider(firebaseConfig.reCaptchaKey),
  true // Set to true to allow auto-refresh.
) */

export default {
  auth,
  authProperty,
  db,
  storage,
  functions,
  firestore,
  log
}
